// extracted by mini-css-extract-plugin
export default {"button":"DatePicker_button__GmseZ","item-clicked":"DatePicker_item-clicked__3KJox","text":"DatePicker_text__+hLHf"};